import { render } from "./photos.vue?vue&type=template&id=e6dd7210&scoped=true"
import script from "./photos.vue?vue&type=script&lang=js"
export * from "./photos.vue?vue&type=script&lang=js"

import "./photos.vue?vue&type=style&index=0&id=e6dd7210&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6dd7210"]])

export default __exports__